var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheTeamWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 32",
    style: {
      enableBackground: "new 0 0 40 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000043426195869262756020000012524042818123393723_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000113315513489756538700000000797982342591077534_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1891",
    style: {
      clipPath: "url(#SVGID_00000113315513489756538700000000797982342591077534_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3578",
    className: "st1",
    d: "M13.6,19H1.1C0.5,19,0,18.5,0,17.8c-0.1-3.1,2.4-5.7,5.5-5.8h3.9c0.8,0,1.5,0.1,2.2,0.5 c-0.1,0.3-0.1,0.7-0.1,1C11.5,15.5,12.2,17.5,13.6,19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    className: "st1",
    d: "M3,5c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5l0,0C5.2,10,3,7.8,3,5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3580",
    className: "st1",
    d: "M13.6,13.5c0-3.6,2.9-6.4,6.5-6.4c3.6,0,6.4,2.9,6.4,6.5c0,3.5-2.9,6.4-6.4,6.4 C16.4,20,13.5,17.1,13.6,13.5C13.5,13.5,13.5,13.5,13.6,13.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    className: "st1",
    d: "M24.1,22.1L24.1,22.1c-0.3,0-0.6,0-1,0h-6.2c-0.3,0-0.6,0-0.9,0h0c-4.4,0.3-7.8,3.9-7.9,8.3 c0,1,0.8,1.7,1.8,1.7c0,0,0,0,0,0h20.5c1,0,1.7-0.7,1.8-1.7c0,0,0,0,0,0C31.9,25.9,28.5,22.4,24.1,22.1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3582",
    className: "st1",
    d: "M27,5c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S27,7.8,27,5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    className: "st1",
    d: "M28.5,13.5c0-0.3,0-0.7-0.1-1c0.7-0.4,1.5-0.5,2.2-0.5h3.9c3.1,0.1,5.6,2.7,5.5,5.8 c0,0.6-0.5,1.1-1.1,1.2H26.4C27.8,17.5,28.5,15.5,28.5,13.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheTeamWhite);
export default __webpack_public_path__ + "static/media/The_Team_White.9ec32076a3302c16eaee43cdd3dc88d5.svg";
export { ForwardRef as ReactComponent };